import React from 'react'
import Modal from 'react-modal'

const ShareModal = ({isOpen, setIsOpen, urlToJoin, urlToEdit, createNewEditURL, saveStatus}) => {
    const [invitePlayerCopy, setInvitePlayerCopy] = React.useState(false);
    const [inviteEditorCopy, setInviteEditorCopy] = React.useState(false);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="bg-white p-6 rounded-lg shadow-lg w-96 mx-auto mt-20 relative"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
        >
            {/* ✕ボタン */}
            <button className='absolute top-4 right-4 text-gray-600 text-lg hover:text-gray-800' onClick={() => setIsOpen(false)}>
                <i className='bi bi-x-lg'></i>
            </button>

            <h2 className='font-bold text-purple-800 text-lg'><i className='bi bi-share me-2'></i>共有</h2>
            
            {/* 未保存の場合の警告表示 */}
            {saveStatus !== 2 && (
                <div className='p-2 flex items-center gap-4'>
                    <i className='bi bi-exclamation-triangle text-xl text-orange-600'></i>
                    <p className='text-gray-700'>共有するためには、ゲームデータを保存してください</p>
                </div>
            )}

            {/* 保存済みの場合のみ共有オプションを表示 */}
            {saveStatus === 2 && (
                <>
                    {/* 編集者を招待（参加用とは別のURL, なければ新しく作成） */}
                    <div className='mt-4'>
                        <h3 className='text-gray-800 font-semibold'><i className='bi bi-person-plus me-2'></i>編集者を招待</h3>
                        <p className='text-gray-600 text-sm'>このURLを利用すれば、誰でもゲームデータを編集できます。</p>
                        
                        {
                            urlToEdit ? (
                                <div className='flex justify-between items-center gap-2'>
                                    <input type="text" className='border border-gray-300 rounded-lg p-2 w-full mt-2' value={urlToEdit} readOnly />
                                    <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-2' onClick={() => {navigator.clipboard.writeText(urlToEdit);setInviteEditorCopy(true); setTimeout(() => setInviteEditorCopy(false), 2000);}}>
                                        { inviteEditorCopy ? (
                                            <i className='bi bi-check-lg'></i>
                                        ) : (
                                            <i className='bi bi-copy'></i>
                                        )}
                                    </button>
                                </div>
                            ) : (
                                <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-2' onClick={() => createNewEditURL()}>URLを作成</button>
                            )
                        }
                    </div>

                    <hr className='my-4' />

                    {/* 参加者招待用のURLをコピー */}
                    <div className='mt-4'>
                        <h3 className='text-gray-800 font-semibold'><i className='bi bi-controller me-2'></i>参加者を招待</h3>
                        
                        <div className='flex justify-between items-center gap-2'>
                            <input type="text" className='border border-gray-300 rounded-lg p-2 w-full mt-2' value={urlToJoin} readOnly />
                            <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-2' onClick={() => {navigator.clipboard.writeText(urlToJoin); setInvitePlayerCopy(true); setTimeout(() => setInvitePlayerCopy(false), 2000);}}>
                                { invitePlayerCopy ? (
                                    <i className='bi bi-check-lg'></i>
                                ) : (
                                    <i className='bi bi-copy'></i>
                                )}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </Modal>
    )
}

export default ShareModal